__turbopack_context__.v({
  "Checkbox": "Input-module-scss-module__hL8JGW__Checkbox",
  "InputV2__root": "Input-module-scss-module__hL8JGW__InputV2__root",
  "Input__FieldFont": "Input-module-scss-module__hL8JGW__Input__FieldFont",
  "Input__Field_Dark": "Input-module-scss-module__hL8JGW__Input__Field_Dark",
  "SelectContainer": "Input-module-scss-module__hL8JGW__SelectContainer",
  "SelectContainerV2": "Input-module-scss-module__hL8JGW__SelectContainerV2",
  "btn": "Input-module-scss-module__hL8JGW__btn",
  "btnContent": "Input-module-scss-module__hL8JGW__btnContent",
  "btnSpinner": "Input-module-scss-module__hL8JGW__btnSpinner",
  "btnSpinnerHidden": "Input-module-scss-module__hL8JGW__btnSpinnerHidden",
  "error": "Input-module-scss-module__hL8JGW__error",
  "is-error": "Input-module-scss-module__hL8JGW__is-error",
  "is-readonly": "Input-module-scss-module__hL8JGW__is-readonly",
  "is-valid": "Input-module-scss-module__hL8JGW__is-valid",
  "selectDropdown": "Input-module-scss-module__hL8JGW__selectDropdown",
  "submitBtnSpin": "Input-module-scss-module__hL8JGW__submitBtnSpin",
});
